import { Flex, Switch, SwitchProps } from '@eigtech/ui-shared-dave'
import { FC } from 'react'
import { get, useController } from 'react-hook-form'
import { BaseProps, FormControl } from '../form-control'

export interface SwitchControlProps extends BaseProps {
  /**
   * Chakra SwitchProps
   */
  switchProps?: SwitchProps
}

export const SwitchControl: FC<SwitchControlProps> = (props: SwitchControlProps) => {
  const { name, control, label, switchProps, ...rest } = props
  const {
    field,
    fieldState: { isTouched },
    formState: { isSubmitting, errors },
  } = useController({
    name,
    control,
    defaultValue: props.switchProps?.defaultChecked || false,
  })
  const error = get(errors, name, '')

  return (
    <FormControl
      alignItems="center"
      as={Flex}
      control={control}
      label={label}
      name={name}
      {...rest}
    >
      <Switch
        {...field}
        id={name}
        isChecked={field.value}
        isDisabled={isSubmitting}
        isInvalid={!!error && isTouched}
        {...switchProps}
      />
    </FormControl>
  )
}

SwitchControl.displayName = 'SwitchControl'

export default SwitchControl
